import { render, staticRenderFns } from "./JobSummary.vue?vue&type=template&id=284fa3de&scoped=true&"
import script from "./JobSummary.vue?vue&type=script&lang=js&"
export * from "./JobSummary.vue?vue&type=script&lang=js&"
import style0 from "./JobSummary.vue?vue&type=style&index=0&id=284fa3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284fa3de",
  null
  
)

export default component.exports